export function readable(value: unknown): string {
  if (value == null || value === "") return "—";
  if (Array.isArray(value)) return value.map(readable).join(", ");
  if (typeof value === "object")
    return Object.entries(value as Record<string, unknown>)
      .slice(0, 4)
      .map(([key, item]) => `${key}: ${readable(item)}`)
      .join(" · ");
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}
export const dateTime = (value: unknown) =>
  value ? new Date(String(value)).toLocaleString() : "—";
export const rawJson = (value: unknown) => JSON.stringify(value, null, 2);
